import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import NodeBlogCard from 'src/components/NodeBlogCard/NodeBlogCard';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';

function BlogPreview({ header, posts }) {
  return (
    <Container fluid className="bg-gray-800 py-6">
      <Container>
        <Row>
          <Col xs={12} className="mb-4 text-white">
            <PortableHeader content={header} />
          </Col>
          <Col xs={12}>
            <Row>
              {posts.map((post) => (
                <Col key={post.id} xs={12} md={6} className="py-3">
                  <NodeBlogCard post={post} darkMode />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

BlogPreview.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.shape()),
};

BlogPreview.defaultProps = {
  posts: [],
};

export default BlogPreview;
